module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005_Content#list",
      "id": "list"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "paraindent1a"
  }, [_c('b', [_vm._v("Archives")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("ANV")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Algemeen Nederlands Verbond Library, Cape Town")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CA")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("State Archives, Cape Archives Depot, Cape Town")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CAD")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("State Archives, Central Archives Depot, Pretoria")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CORY")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Rhodes University, Cory Library, Grahamstown")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("DPL")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Durban Public Library")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("INCH")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("University of the Free State, Institute for Contemporary History,\nBloemfontein")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NFA")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("National Film and Video Archives, Pretoria")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SABC")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("South African Broadcasting Corporation Sound Archives, Johannesburg")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SAL")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("National Library of South Africa, Cape Town")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("UCT, ASL")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("University of Cape Town, African Studies Library")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("UCT, MA")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("University of Cape Town, Manuscripts and Archives")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("US")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("University of Stellenbosch Document Center")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WITS (A)")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("University of Witwatersrand Archives")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WITS (HP)")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("University of Witwatersrand, Historical Papers")])])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1a"
  }, [_c('b', [_vm._v("Organizations and Institutions")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "80%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("AAC")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("All African Convention")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ACVV")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Afrikaanse Christelike Vroue Vereneging [Afrikaner Christian\nWomen’s Organization]")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ANC")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("African National Congress")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ANCYL")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("African National Congress Youth League")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Anti-CAD")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Anti-Coloured Affairs Department")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ANV")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Algemeen Nederlands Verbond")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("APO")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("African Political Organisation")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ATKV")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Afrikaans Taal en Kultuur Vereniging [Afrikaans Language and\nCultural Association]")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CATA")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Cape African Teachers Association")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CPNU")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Coloured People’s National Union")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("DRC")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Dutch Reformed Church")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("FAK")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Federasie van Afrikaanse Kultuurverenigings [Federation of Afrikaans\nCultural Associations]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_vm._v("FRAC")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Franchise Action Council")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("GRA")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Genootskap van Regte Afrikaners [Fellowship of True Afrikaners]")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NAD")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Native Affairs Department")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NEUM")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Non-European Unity Movement")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SAIC")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("South African Indian Congress")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("TEPA")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Teachers Educational and Professional Association")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("TLSA")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Teachers League of South Africa")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("TRC")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Truth and Reconciliation Commission")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("UCT")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("University of Cape Town")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WPBTL")]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v("Western Province Bantu Teachers League")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33f091f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Abbreviations.vue
// module id = 78
// module chunks = 0